import React from 'react';
import api from '~/modules/services/api-service';
// import { useSession, SignIn } from '@clerk/clerk-react';
import {
	useSession,
	SignIn,
	// UserProfile,
	useClerk
	// UserButton,
} from '@clerk/clerk-react';

export default function ClerkAuthModal() {
	let session = useSession();
	const clerk = useClerk();
	api.clerk = clerk;

	// if (session?.session && !session.session.user.twoFactorEnabled) {
	// 	return (
	// 		<div
	// 			style={{
	// 				display: "flex",
	// 				flexDirection: "column",
	// 				justifyContent: "center",
	// 				alignItems: "center",
	// 				height: "100vh",
	// 			}}
	// 		>
	// 			<div style={{ marginBottom: "20px" }}>
	// 				Two factor verification is required for Pixwel Platform access.
	// 			</div>
	// 			<UserProfile />
	// 			{/* <UserButton /> */}
	// 		</div>
	// 	);
	// }

	if(session?.session) {
		return null;
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh'
			}}
		>
			<SignIn
				appearance={{
					elements: {
						footerAction: { display: 'none' }
					}
				}}
			/>
		</div>
	);
}
